<script lang="ts">

    export let flex = false;
    export let mainBackground = false;
    export let zIndex = 2;

</script>

<div
    class="view"
    class:flex
    class:main-background={mainBackground}
    style="--zIndex: {zIndex};">
    <slot />
</div>

<style lang="scss">

    .view {
        position: fixed;
        z-index: var(--zIndex);
        top: 0;
        left: calc(50% - min(50vw, 250px));
        width: 100vw;
        height: var(--vh, 100vh);
        max-width: 500px;
        touch-action: auto;
        pointer-events: auto;
        background-color: #fff;

        &.flex {
            display: flex;
            flex-direction: column;
        }
    }

</style>
